import { computed, onUnmounted, ref } from 'vue'
import { useStore } from 'vuex'

import { mapRelationship } from '@/store/mappers'

const COPIED_FOR_MS = 2200

export function useStorefrontLink() {
  const store = useStore()

  const host = computed(
    () => mapRelationship(store.state.loggedInUser?.relationships?.default_subdomain?.data)?.attributes?.name || ''
  )
  const url = computed(() => (host.value ? `https://${host.value}` : ''))
  const canCopy = computed(() => !!url.value && typeof navigator !== 'undefined' && !!navigator.clipboard)

  const copied = ref(false)
  let timer = null

  const copy = async () => {
    if (!canCopy.value) return
    try {
      await navigator.clipboard.writeText(url.value)
    } catch {
      return
    }
    copied.value = true
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      copied.value = false
    }, COPIED_FOR_MS)
  }

  onUnmounted(() => {
    if (timer) clearTimeout(timer)
  })

  return { host, url, canCopy, copied, copy }
}
